import { FooterMenu } from '@/types/typo3/Footer'
import { Button } from '@/ui/components'

interface Props {
  data: FooterMenu
}

const Menu = ({ data }: Props) => {
  if (!data?.menu.length) {
    return null
  }

  return (
    <div className="gap-md flex flex-col">
      <h4 className="textstyle-md-bold text-primary-300/50">{data?.title}</h4>
      <div className={'gap-xs flex flex-col items-start'}>
        {data?.menu.map((item, index) => (
          <Button
            key={index?.toString()}
            className={'justify-start'}
            href={item.link}
            variant="text"
            size="m"
            target={item.target !== '' ? item.target : undefined}
            nextLink={item.target === '' ? true : false}
            isTransition={item.target === '' ? true : false}
            allowDisable={false}
          >
            {item.title}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default Menu
